<template>
  <v-dialog
    v-model="shown"
    max-width="967"
    @click:outside="cancel"
  >
  <div v-if="asyncDataStatus_ready" class="col-full push-top popup">
    <h2>
      Dodajte nov dogodek:
    </h2>
    <WorktimeForm
      @submit="save"
      @cancel="cancel"
      :users="users"
      :article="article"
      :dateLastNextSessions="dateLastNextSessions"
      ref="form"
    />
  </div>
  </v-dialog>
</template>

<script>
import { mapActions } from 'vuex'
import WorktimeForm from '@/components/WorktimeForm'
import asyncDataStatus from '@/mixins/asyncDataStatus'
import { objectToArray } from '@/utils/object'

export default {
  data () {
    return {
      shown: false
    }
  },
  components: {
    WorktimeForm,
  },
  mixins: [
    asyncDataStatus
  ],
  props: {
    article: {
      default: null,
      type: Object
    },
    dateLastNextSessions: {
      type: Object,
    }
  },
  computed: {
    users () {
      return objectToArray(this.$store.state.users.items).sort((a, b) => (a.moniker ? a.moniker.toLowerCase() : a.complete_name.toLowerCase()) > (b.moniker ? b.moniker.toLowerCase() : b.complete_name.toLowerCase()) ? 1 : -1)
    }
  },
  methods: {
    ...mapActions('delovnicas', { saveForm: 'addUserWorkTime' }),
    ...mapActions('users', { loadUsers: 'loadItems' }),
    save ({ data }) {
      console.log('data: ', data)
      this.saveForm(data)
        .then(item => {
          console.log('closing')
          this.cancel(data)
          /* setTimeout(() => {
            this.$refs.form.clearForm()
          }, 1000); */
        })
    },
    cancel (data) {
      this.shown = false
      this.$emit('zapri', data)
    }
  },
  created () {
    this.shown = false
    Promise.all([
      this.loadUsers()
    ])
      .then(items => {
        this.asyncDataStatus_fetched()
        this.shown = true
      })
  }
}
</script>

<style lang="scss" scoped>
.popup {
  background-color: #fff;
  padding: 1rem;
}
</style>
